import React from 'react';
import { Separator } from "./CommonStyles";

const CustomSeparator = ({
    width,
    height,
    testid
}) => {

    return (
        <Separator
            width={width}
            height={height}
            testid={testid}
        />
    );
    
};

export default CustomSeparator;